// AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import api from '../api/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [authReady, setAuthReady] = useState(false);

  const fetchCurrentUser = async () => {
    const token = localStorage.getItem('jwtToken');

    if (!token) {
      setIsAuthenticated(false);
      setUserType(null);
      setUserEmail('');
      setAuthReady(true);
      return;
    }

    try {
      const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/api/auth/current-user`);
      if (response.data.isAuthenticated) {
        setIsAuthenticated(true);
        setUserType('registered');
        if (response.data.user.email) {
          setUserEmail(response.data.user.email);
        }
      } else {
        setIsAuthenticated(false);
        setUserType(null);
        setUserEmail('');
      }
    } catch (error) {
      console.error('Error fetching current user:', error);
      setIsAuthenticated(false);
      setUserType(null);
      setUserEmail('');
    } finally {
      setAuthReady(true);
    }
  };

  useEffect(() => {
    const handleTokenFromUrl = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = urlParams.get('token');

      if (tokenFromUrl) {
        // Clear any existing token first
        localStorage.removeItem('jwtToken');

        // Store the token
        localStorage.setItem('jwtToken', tokenFromUrl);

        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname);

        // Check authentication with new token
        await fetchCurrentUser();
        
      } else {
        // No token in URL, just check current authentication
        await fetchCurrentUser();
      }
    };

    handleTokenFromUrl();
  }, []);

  const value = {
    isAuthenticated,
    setIsAuthenticated,
    userType,
    setUserType,
    userEmail,
    setUserEmail
  };

  if (!authReady) {
    return null;
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
